@if (contactDetailsMap.length) {
  <div class="details-section__title">Contact Details</div>
  <div class="details-section">
    @for (item of contactDetailsMap; track $index) {
      <div>
        <h6 class="details-section__label">{{ item[0] }}</h6>
        <p class="details-section__value">{{ item[1] || 'Unknown' }}</p>
      </div>
    }
  </div>
}

@if (appointmentDetailsMap.length) {
  <div class="details-section__title">Appointment Details</div>
  <div class="details-section">
    @for (item of appointmentDetailsMap; track $index) {
      <div>
        <h6 class="details-section__label">{{ item[0] }}</h6>
        <p class="details-section__value">{{ item[1] || 'Unknown' }}</p>
      </div>
    }
  </div>
}

@if (leasingPreferencesMap.length) {
  <div class="details-section__title">Leasing Preferences</div>
  <div class="details-section">
    @for (item of leasingPreferencesMap; track $index) {
      <div>
        <h6 class="details-section__label">{{ item[0] }}</h6>
        <p class="details-section__value">{{ item[1] || 'Unknown' }}</p>
      </div>
    }
  </div>
}

@if (campaignDetailsMap.length) {
  <div class="details-section__title">Campaign Details</div>
  <div class="details-section">
    @for (item of campaignDetailsMap; track $index) {
      <div>
        <h6 class="details-section__label">{{ item[0] }}</h6>
        <p class="details-section__value">{{ item[1] || 'Unknown' }}</p>
      </div>
    }
  </div>
}

@if (conversationDetailsMap.length) {
  <div class="details-section__title">Conversation Details</div>
  <div class="details-section">
    @for (item of conversationDetailsMap; track $index) {
      <div>
        <h6 class="details-section__label">{{ item[0] }}</h6>
        <p class="details-section__value">{{ item[1] || 'Unknown' }}</p>
      </div>
    }
  </div>
}

<div class="html2pdf__page-break"></div>
